// extracted by mini-css-extract-plugin
export default {"helper-count":"Dropzone_helper-count__Z-qKV"};